module.exports = __webpack_public_path__ + "f04d56bb39e3c0cb384de856316c0b7b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/single-note-poster.png
// module id = 1641
// module chunks = 0